import React, { useState } from "react";
import AchievementCard from "./AchievementCard";
import AchievementModal from "./AchievementModal";
import "../../styles/Achievements.css";

const CATEGORY_LABELS = {
  getting_started: "شروع کار",
  planning: "برنامه‌ریزی",
  consistency: "پایداری",
  cooking: "آشپزی",
  challenges: "چالش‌ها",
  community: "انجمن",
  meta: "متفرقه",
};

const CATEGORY_ORDER = [
  "getting_started",
  "planning",
  "consistency",
  "cooking",
  "challenges",
  "community",
  "meta",
];

// Renders `achievements` grouped by category with Farsi headers; clicking a
// card opens the shared AchievementModal for its details.
function AchievementGrid({ achievements }) {
  const [selected, setSelected] = useState(null);

  if (!achievements || achievements.length === 0) {
    return <p className="caption-1 grey-2 centerAlign yekan marginTop5">دستاوردی پیدا نشد</p>;
  }

  const grouped = {};
  achievements.forEach((a) => {
    const cat = a.category || "meta";
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(a);
  });

  const knownCategories = CATEGORY_ORDER.filter((c) => grouped[c] && grouped[c].length > 0);
  const otherCategories = Object.keys(grouped).filter((c) => !CATEGORY_ORDER.includes(c));
  const categories = knownCategories.concat(otherCategories);

  return (
    <div>
      {categories.map((cat) => (
        <div key={cat} className="achievementCategorySection">
          <p className="heading-3 rightAlign marginBottom1r">{CATEGORY_LABELS[cat] || cat}</p>
          <div className="achievementGrid">
            {grouped[cat].map((a) => (
              <AchievementCard key={a.achievement_id} achievement={a} onClick={setSelected} />
            ))}
          </div>
        </div>
      ))}

      <AchievementModal achievement={selected} onClose={() => setSelected(null)} />
    </div>
  );
}

export default AchievementGrid;
